import ReactDOM from "react-dom/client";

import MeetusVRApp from "./App";

import "./Styles/style.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<MeetusVRApp />);

